var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import { computed } from '@ember/object';
import { array, fragment, fragmentArray } from 'ember-data-model-fragments/attributes';
import { isNone } from '@ember/utils';
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
import { CatalogPricingType as CatalogPricingTypeProto, InventoryAlertType as InventoryAlertTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
export let PricingType = /*#__PURE__*/function (PricingType) {
  PricingType["FIXED_PRICING"] = "FIXED_PRICING";
  PricingType["VARIABLE_PRICING"] = "VARIABLE_PRICING";
  return PricingType;
}({});
export let InventoryAlertType = /*#__PURE__*/function (InventoryAlertType) {
  InventoryAlertType["INVENTORY_ALERT_TYPE_DO_NOT_USE"] = "INVENTORY_ALERT_TYPE_DO_NOT_USE";
  InventoryAlertType["NONE"] = "NONE";
  InventoryAlertType["LOW_QUANTITY"] = "LOW_QUANTITY";
  return InventoryAlertType;
}({});
let Data = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('number', {
  defaultValue: 1
}), _dec5 = attr('string', {
  protoEnum: CatalogPricingTypeProto,
  defaultValue: PricingType.VARIABLE_PRICING
}), _dec6 = fragment('price-money'), _dec7 = attr('boolean', {
  allowNull: true
}), _dec8 = attr('string', {
  protoEnum: InventoryAlertTypeProto,
  defaultValue: InventoryAlertType.NONE
}), _dec9 = attr('number'), _dec10 = attr('string'), _dec11 = attr('string'), _dec12 = fragmentArray('connect/item-variation/location-override'), _dec13 = attr('string'), _dec14 = attr('number'), _dec15 = attr('string'), _dec16 = attr('boolean', {
  allowNull: true
}), _dec17 = fragment('price-money'), _dec18 = attr('number'), _dec19 = fragment('price-money'), _dec20 = attr('string'), _dec21 = attr('number'), _dec22 = attr('string'), _dec23 = array(), _dec24 = attr('boolean', {
  allowNull: true
}), _dec25 = attr('boolean', {
  allowNull: true
}), _dec26 = attr('string'), _dec27 = fragment('connect/item-variation/bundle'), _dec28 = fragment('connect/item-variation/recipe'), _dec29 = array(), _dec30 = array(), _dec31 = fragment('connect/stock-conversion'), _dec32 = array(), _dec33 = attr('string'), _dec34 = attr('string'), _dec35 = fragment('price-money'), _dec36 = array(), _dec37 = fragmentArray('connect/channel-integrations'), _dec38 = fragment('connect/item-variation/weight'), _dec39 = computed('serviceCostPercentage'), _dec40 = computed('serviceCostFlat.amount', 'priceMoney.amount', 'pricingType'), _class = (_class2 = class Data extends CatalogFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "itemId", _descriptor, this);
    _initializerDefineProperty(this, "name", _descriptor2, this);
    _initializerDefineProperty(this, "sku", _descriptor3, this);
    _initializerDefineProperty(this, "ordinal", _descriptor4, this);
    _initializerDefineProperty(this, "pricingType", _descriptor5, this);
    _initializerDefineProperty(this, "priceMoney", _descriptor6, this);
    _initializerDefineProperty(this, "trackInventory", _descriptor7, this);
    _initializerDefineProperty(this, "inventoryAlertType", _descriptor8, this);
    _initializerDefineProperty(this, "inventoryAlertThreshold", _descriptor9, this);
    _initializerDefineProperty(this, "buyerFacingName", _descriptor10, this);
    _initializerDefineProperty(this, "userData", _descriptor11, this);
    _initializerDefineProperty(this, "locationOverrides", _descriptor12, this);
    _initializerDefineProperty(this, "upc", _descriptor13, this);
    _initializerDefineProperty(this, "serviceDuration", _descriptor14, this);
    _initializerDefineProperty(this, "priceDescription", _descriptor15, this);
    _initializerDefineProperty(this, "availableForBooking", _descriptor16, this);
    _initializerDefineProperty(this, "noShowFee", _descriptor17, this);
    _initializerDefineProperty(this, "noShowFeePercentage", _descriptor18, this);
    _initializerDefineProperty(this, "serviceCostFlat", _descriptor19, this);
    _initializerDefineProperty(this, "serviceCostPercentage", _descriptor20, this);
    _initializerDefineProperty(this, "transitionTime", _descriptor21, this);
    _initializerDefineProperty(this, "measurementUnitId", _descriptor22, this);
    _initializerDefineProperty(this, "itemOptionValues", _descriptor23, this);
    _initializerDefineProperty(this, "sellable", _descriptor24, this);
    _initializerDefineProperty(this, "stockable", _descriptor25, this);
    _initializerDefineProperty(this, "compositionId", _descriptor26, this);
    _initializerDefineProperty(this, "bundle", _descriptor27, this);
    _initializerDefineProperty(this, "recipe", _descriptor28, this);
    _initializerDefineProperty(this, "imageIds", _descriptor29, this);
    _initializerDefineProperty(this, "teamMemberIds", _descriptor30, this);
    _initializerDefineProperty(this, "stockableConversion", _descriptor31, this);
    _initializerDefineProperty(this, "subscriptionPlanIds", _descriptor32, this);
    _initializerDefineProperty(this, "kitchenName", _descriptor33, this);
    _initializerDefineProperty(this, "contractTemplateToken", _descriptor34, this);
    _initializerDefineProperty(this, "defaultUnitCost", _descriptor35, this);
    _initializerDefineProperty(this, "channels", _descriptor36, this);
    _initializerDefineProperty(this, "channelIntegrations", _descriptor37, this);
    _initializerDefineProperty(this, "weight", _descriptor38, this);
  }
  get isVariablePriced() {
    return this.pricingType === PricingType.VARIABLE_PRICING || isNone(this.priceMoney?.amount);
  }
  get hasValidServiceCostPercentage() {
    return this.serviceCostPercentage >= 0 && this.serviceCostPercentage <= 100;
  }
  get hasValidServiceCostFlat() {
    return this.pricingType === 'VARIABLE_PRICING' || this.pricingType === 'FIXED_PRICING' && this.priceMoney !== null && this.priceMoney.amount >= this.serviceCostFlat.amount;
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/item-variation/data'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "itemId", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sku", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "ordinal", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "pricingType", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "priceMoney", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "trackInventory", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "inventoryAlertType", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "inventoryAlertThreshold", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "buyerFacingName", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "userData", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "locationOverrides", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "upc", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "serviceDuration", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "priceDescription", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "availableForBooking", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "noShowFee", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "noShowFeePercentage", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "serviceCostFlat", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "serviceCostPercentage", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "transitionTime", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "measurementUnitId", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "itemOptionValues", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "sellable", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "stockable", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "compositionId", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "bundle", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "recipe", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "imageIds", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "teamMemberIds", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "stockableConversion", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "subscriptionPlanIds", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "kitchenName", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "contractTemplateToken", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "defaultUnitCost", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "channels", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "channelIntegrations", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "weight", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "hasValidServiceCostPercentage", [_dec39], Object.getOwnPropertyDescriptor(_class.prototype, "hasValidServiceCostPercentage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasValidServiceCostFlat", [_dec40], Object.getOwnPropertyDescriptor(_class.prototype, "hasValidServiceCostFlat"), _class.prototype), _class);
export { Data as default };